<script lang="ts">
	import type { Snippet } from "svelte";
	import { cn } from "#lib/web-ui/ui/utils.js";
	import ArrowRightIcon from "@lucide/svelte/icons/arrow-right";
	import PropertyCardSkeleton from "./property-card-skeleton.svelte";

	interface Props {
		title: string;
		subtitle?: string;
		viewMoreHref: string;
		viewMoreLabel?: string;
		listingCount: number;
		cards: Snippet;
		class?: string;
	}

	let {
		title,
		subtitle,
		viewMoreHref,
		viewMoreLabel = "View all",
		listingCount,
		cards,
		class: className
	}: Props = $props();

	const skeletonCount = 4;
</script>

<div class={cn("py-6", className)}>
	<div class="mx-auto max-w-[84rem] px-4 md:px-6">
		<div class="mb-5 flex items-center justify-between">
			<div>
				<h2 class="text-foreground text-xl font-bold sm:text-2xl">{title}</h2>
				{#if subtitle}
					<p class="text-muted-foreground mt-1 text-sm">{subtitle}</p>
				{/if}
			</div>
			{#if listingCount > 0}
				<a
					href={viewMoreHref}
					class="text-primary hover:text-primary/80 hidden items-center gap-1 text-sm font-medium sm:flex"
				>
					{viewMoreLabel}
					<ArrowRightIcon class="h-4 w-4" />
				</a>
			{/if}
		</div>

		{#if listingCount > 0}
			<div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
				{@render cards()}
			</div>
			<div class="mt-4 sm:hidden">
				<a
					href={viewMoreHref}
					class="text-primary hover:text-primary/80 flex items-center gap-1 text-sm font-medium"
				>
					{viewMoreLabel}
					<ArrowRightIcon class="h-4 w-4" />
				</a>
			</div>
		{:else}
			<div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
				{#each Array(skeletonCount) as _, i (i)}
					<PropertyCardSkeleton />
				{/each}
			</div>
		{/if}
	</div>
</div>
